import { render, staticRenderFns } from "./BtnRemoverItemRequisicaoRateio.vue?vue&type=template&id=76494e44"
import script from "./BtnRemoverItemRequisicaoRateio.vue?vue&type=script&lang=js"
export * from "./BtnRemoverItemRequisicaoRateio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports